import { useMemo } from "react";

import type { FormBuilderActions } from "containers/admin/clients/client/components/form-builder/form-builder-action-button";
import { createFormBuilderViewerFields } from "containers/admin/clients/client/components/form-builder/form-builder-viewer-fields";
import {
  mergeDefaultValues,
  normalizeJsonFormSchema,
  type DynamicFormSchema,
} from "containers/admin/clients/client/components/form-builder/form-schema";

type FormBuilderViewerProps = {
  schema: DynamicFormSchema;
  values?: Record<string, unknown>;
  actions?: FormBuilderActions;
};

const FormBuilderViewer = ({ schema, values, actions }: FormBuilderViewerProps) => {
  const normalizedSchema = useMemo(() => normalizeJsonFormSchema(schema), [schema]);
  const resolvedValues = useMemo(
    () => mergeDefaultValues(normalizedSchema, values),
    [normalizedSchema, values],
  );

  const { renderFields } = useMemo(
    () => createFormBuilderViewerFields({ formData: resolvedValues, actions }),
    [actions, resolvedValues],
  );

  return <div className="flex flex-col gap-4">{renderFields(normalizedSchema)}</div>;
};

export default FormBuilderViewer;
